import * as React from 'react';

/** Material UI Packages. */
import { Box, Paper } from '@mui/material';

/** Dompurify Packages. */
import DOMPurify from 'dompurify';

/** Quill stylesheet — the same rules the editor (shared/ui/TextEditor) renders with. */
import 'quill/dist/quill.snow.css';

/**
 * Dedicated sanitizer for the read screen. DOMPurify drops `target` by default (and the
 * body was already sanitized once on save), so every stored link lands without one and
 * would navigate inside the app tab. Force links to open in a new tab instead.
 */
const purify = DOMPurify();
purify.addHook('afterSanitizeAttributes', (node) => {
    if (node.tagName === 'A' && node.hasAttribute('href')) {
        node.setAttribute('target', '_blank');
        node.setAttribute('rel', 'noopener noreferrer');
    }
});

/**
 * Guideline detail panel component.
 * @param {Object} props - Component props.
 * @param {Object} props.row - Guideline row data.
 * @returns {JSX.Element} Detail panel component.
 */
const GuidelineDetailPanel = ({ row }) => {
    return (
        <Box sx={{ backgroundColor: '#f8f8f8', px: 2, py: 2 }}>
            <Paper sx={{ backgroundColor: '#ffffff', mx: '20vw', px: 2, py: 2 }}>
                <Box
                    className="ql-container ql-snow"
                    sx={{ '&.ql-container.ql-snow': { border: 0, height: 'auto', fontFamily: 'NotoSans' } }}
                >
                    <Box
                        className="ql-editor"
                        data-testid="guideline-body"
                        dangerouslySetInnerHTML={{ __html: purify.sanitize(row.body || '') }}
                        sx={{
                            '&.ql-editor': {
                                padding: 0,
                                height: 'auto',
                                overflow: 'visible',
                            },
                            '&.ql-editor > *': { cursor: 'inherit' },
                        }}
                    />
                </Box>
            </Paper>
        </Box>
    );
};

export default GuidelineDetailPanel;
